<script>
    export default {
        // Show or hide error message
        bind(el, binding, vnode) {
            el.applyValidationStyle = function() {
                var validator = vnode.context.$v;
                var dataString = binding.value || '';

                // Get rule
                var rule = dataString.split(':')[1];
                dataString = dataString.split(':')[0];

                // Get path, remove empty segments
                var path = dataString.split('.').filter(function (item) {
                    return item.trim() !== '';
                });

                // If path empty, try to guess validator name
                if (path.length < 1 ) {
                    var elementName = el.id || el.name;
                    if (elementName) {
                        path.push(elementName);
                    }
                }

                // if path has one segment and segment not property of validator
                if (path.length === 1 && !validator.hasOwnProperty(path[0])) {
                   // Loop through validator
                    for (var property in validator) {
                        if (validator.hasOwnProperty(property)) {
                            // Add segement to path if property does has the first segment
                            if (property.indexOf('$') !== 0 && validator[property].hasOwnProperty(path[0])) {
                                path.unshift(property);
                                break;
                            }
                        }
                    }
                }

                // Get validation object from path
                var validatorObject = vnode.context.$v;
                for (let i = 0; i < path.length; i++) {
                    validatorObject = validatorObject[path[i]];
                }

                if (!validatorObject) {
                    console.error('No validation found for path: ', path);
                    return;
                }

                // Invalid when control is invalid and rule is undefined, or
                // when control is invalid rule attribute has value  'false' (=== invalid)
                var invalid = validatorObject.$invalid && (!rule || !validatorObject[rule])

                if (this.tagName === 'INPUT') {
                    if (vnode.context.isSubmitted && invalid) {
                        el.classList.add('is-invalid');
                    } else {
                        el.classList.remove('is-invalid');
                    }
                } else {
                    if (vnode.context.isSubmitted && invalid) {
                        el.classList.add('is-invalid');
                        el.classList.add('d-block');
                        el.classList.remove('d-none');
                    } else {
                        el.classList.remove('is-invalid');
                        el.classList.remove('d-block');
                        el.classList.add('d-none');
                    }
                }
            };

            el.applyValidationStyle();
        },

        update(el, binding, vnode) {
            el.applyValidationStyle();
        },

    }
</script>
